export const resolveGroupLabel = (rawKey, groupLabelByKey) => {
  if (!groupLabelByKey || typeof groupLabelByKey !== 'object') return null
  const direct = groupLabelByKey[rawKey]
  if (direct) return direct
  const byString = groupLabelByKey[String(rawKey)]
  if (byString) return byString
  return null
}
